import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  
  constructor() { }

  getCurrentPosition(): Promise<{latitude: string, longitude: string, address: string}> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation is not supported by this browser.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude.toString();
          const longitude = position.coords.longitude.toString();
          
          // Use reverse geocoding to get address (simplified version)
          this.reverseGeocode(latitude, longitude)
            .then(address => {
              resolve({
                latitude,
                longitude,
                address
              });
            })
            .catch(() => {
              // Fallback to coordinates if reverse geocoding fails
              resolve({
                latitude,
                longitude,
                address: `${latitude}, ${longitude}`
              });
            });
        },
        (error) => {
          console.warn('Geolocation error:', error);
          // Return default values
          resolve({
            latitude: '0.0',
            longitude: '0.0',
            address: 'Location not available'
          });
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000 // 5 minutes
        }
      );
    });
  }

  private reverseGeocode(latitude: string, longitude: string): Promise<string> {
    return new Promise((resolve, reject) => {
      // You can use any reverse geocoding service here
      // For now, we'll use a simple format
      // In production, you might want to use Google Maps API or similar
      
      // Simple fetch to a geocoding service (you'll need to implement this)
      // For now, return a formatted string
      const address = `${latitude}, ${longitude}`;
      resolve(address);
    });
  }
}